// 退出免审
export const exitExemptExamine = (params) => {
  return window._this.$http.post(`/erp/Supply/exitExemptExamine`, params);
};
// 设置商家商家性质
export const setSupplyCharacter = (params) => {
  return window._this.$http.post(`/erp/Supply/setSupplyCharacter`, params);
};

// 批量修改退换货收货地址模板
export const exportExchangeGoodsExpressBackLink = (params) => {
  return window._this.$http.post(
    `/erp/Supply/exportExchangeGoodsExpressBackLink`,
    params
  );
};



// WEBPACK FOOTER //
// ./src/api/update-supply.js